import App from './ts/main';
import './styles/index.scss';
// import * as THREE from 'three';
const app = new App();
// window['THREE'] = THREE;
